import { render, staticRenderFns } from "./TasksToObserveList.vue?vue&type=template&id=49010ab8"
import script from "./TasksToObserveList.vue?vue&type=script&lang=js"
export * from "./TasksToObserveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports